import Vue from 'vue'
import VueRouter from 'vue-router'

// Views
import UserSettings from '../../../components/view-user-settings.vue';
import ChangePassword from '../../../components/view-change-password.vue';
import EditAccount from '../../../components/view-edit-account.vue';

Vue.use(VueRouter)

const Router = (options) => {
  return new VueRouter({
    mode: 'history',
    base: options.base,
    linkActiveClass: 'v-router-link__active',
    linkExactActiveClass: 'v-router-link__current',
    routes: [
      {
        path: '/', name: 'user-settings', component: UserSettings,
        children: [
          {
            // UserProfile will be rendered inside User's <router-view>
            // when /user/:id/profile is matched
            name: 'change-password',
            path: 'change-password',
            component: ChangePassword
          },
          {
            // UserPosts will be rendered inside User's <router-view>
            // when /user/:id/posts is matched
            name: 'edit-account',
            path: 'edit-account',
            component: EditAccount
          }
        ]
      }
    ]
  })
}

export default Router;
